import type { Device } from "@medplum/fhirtypes";
import { DEVICE_COLLECTION_NAME } from "../../fhir";
import { createSubscriptionHook } from "./create-subscription-hook";

/**
 * Hook that subscribes to Device resource changes via WebSocket
 * and updates the TanStack DB collection in real-time.
 *
 * Must be used inside FhirDataStoreProvider.
 */
export const useDeviceSubscription = createSubscriptionHook<Device>("Device", DEVICE_COLLECTION_NAME);
